import cuid from "cuid";
import View from "./View";

const Detail = ({ updateQualifier, setOpenDetail, openDetail }) => {
  const onClose = () => setOpenDetail({});

  const onSubmit = (data) => {
    const { name, description, tag, events = [] } = data;
    return updateQualifier({
      variables: {
        where: { id: openDetail?.id },
        data: {
          name,
          description,
          tag,
          events: events.map((type) => ({ id: cuid(), type })),
        },
      },
    });
  };

  return <View onSubmit={onSubmit} onClose={onClose} open={openDetail} />;
};

export default Detail;
